import React from "react";
import { Helmet } from "react-helmet";
import "./FAQ.css";

const FAQ = () => {
  return (
    <div className="container">
      <Helmet>
        <title>FAQ | Doggy Duty WNY - Pet Waste Removal</title>
        <meta
          name="description"
          content="Find answers to common questions about Doggy Duty WNY's pet waste removal services, pricing, scheduling, and more."
        />
        <meta name="keywords" content="Dog waste removal FAQ, Doggy Duty WNY questions, pet waste cleanup service" />
        <meta name="author" content="Doggy Duty WNY" />
      </Helmet>

      {/* Page Title */}
      <section className="faq-title text-center py-5">
        <h1>Frequently Asked Questions</h1>
      </section>

      {/* FAQ List */}
      <section className="faq-section py-5">
        <div className="faq-item">
          <h3>How does pet waste removal services work?</h3>
          <p>
            We visit your property on a scheduled basis to remove pet waste using sanitized equipment. All waste is securely bagged and disposed of responsibly, ensuring a clean and odor-free yard.
          </p>
        </div>

        <div className="faq-item">
          <h3>Does Doggy Duty WNY clean the entire yard?</h3>
          <p>
          Absolutely! We remove pet waste from all areas of your property, including front, back, and side yards, flower beds, dog runs, patios, and any other problem spots. Wherever your pup goes, we go!
          </p>
        </div>

        <div className="faq-item">
          <h3>Do you provide dog waste removal services year-round?</h3>
          <p>
          Yes! Doggy Duty WNY operates all year, no matter the season. Even in winter, we do our best to keep your yard clean. In snowy conditions, we scoop what’s accessible and ensure no waste piles up over time.
          </p>
        </div>

        <div className="faq-item">
          <h3>How do you ensure the safety of my dogs?</h3>
          <p>
            Your pet’s safety is our top priority! We sanitize all equipment and footwear between each visit using a kennel-grade disinfectant to prevent the spread of bacteria. Our team also takes gate pictures after every cleaning, so you’ll always know your yard is secure. Plus, all our employees are background-checked for your peace of mind.
          </p>
        </div>

        <div className="faq-item">
          <h3>How much does it cost to hire a professional pooper scooper?</h3>
          <p>
          Our pet waste removal plans start at just $50 per month. Pricing depends on frequency of service, and the number of dogs. Most of our customers pay between $70 and $90 per month for regular, hassle-free cleanups.
          </p>
        </div>

        <div className="faq-item">
          <h3>Do I have to sign a contract for pet waste removal services?</h3>
          <p>
            No contracts—just clean yards! You can start, pause, or cancel your service anytime through our customer portal or by giving us a call.
          </p>
        </div>


        <div className="faq-item">
          <h3>How do you dispose of the pet waste after each cleanup?</h3>
          <p>
          We securely bag all pet waste and dispose of it in your designated trash can. Our team ensures everything is neatly contained so your yard stays fresh and odor-free.
          </p>
        </div>

        <div className="faq-item">
          <h3>Can you clean while my dog is in the yard?</h3>
          <p>
          Yes! We love working with dogs. If your pup is friendly, they can roam while we clean. However, for the safety of our team, if your dog has ever shown aggression, we kindly ask that they be kept inside during the service.
          </p>
        </div>

        <div className="faq-item">
          <h3>Can I request a specific cleanup day?</h3>
          <p>
          Yes, you can request a specific cleanup day. Not every cleanup day will be available in your area, but we can generally offer 2-3 options to best fit your schedule.
          </p>
        </div>

        <div className="faq-item">
          <h3>Do you provide arrival windows for service?</h3>
          <p>
          Yes, we do! Doggy Duty WNY sends a text notification one week before your scheduled service and another one hour before we arrive, so you’ll always know when to expect us.
          </p>
        </div>







      </section>
    </div>
  );
};

export default FAQ;
